module.exports = __webpack_public_path__ + "static/media/Img-banner-Consumidor-Ebit-03.05b67b40.05b67b40.png";